import React, { useEffect, useState } from 'react';
import {
	BreadcrumbNav,
	CenterPanel,
	LeftPanel,
	PageHeading,
	RightPanel
} from '../../components/layout';
import MaintenanceLeftSideNavigation from '../../components/Maintenance/MaintenanceLeftSideNavigation';
import { Button } from 'react-bootstrap';
import ResponseAlert, { TOAST_TYPES } from '../../components/ResponseAlert';
import TableWithIntegration from '../../components/layout/TableWithIntegration/TableWithIntegration';
import { useBackendPaginationFetcher, usePagePermissions } from '../../hooks';
import OfficerForm from './OfficerForm';
import { officerServices } from '../../services/officerServices';
import { SUCCESSFUL_REQUEST_CODE } from '../../utils';

const OfficerMaintenance = () => {
	const FormType = Object.freeze({
		add: 'ADD',
		edit: 'EDIT'
	});
	const [formType, setFormType] = useState(FormType.add);
	const [showFormDialog, setShowFormDialog] = useState(false);
	const { putOfficerData } = officerServices();
	const [formValues, setFormValues] = useState({});
	const [toast, setToast] = useState({
		show: false,
		text: '',
		type: ''
	});
	const coulmns = [
		{ value: 'badgeNo', heading: 'Badge Number' },
		{ value: 'officerName', heading: 'Officer Name' },
		{ value: 'department', heading: 'Agency' }
	];

	const { permissions } = usePagePermissions('officer');
	const { isLoading, data, paginationItems, refreshTable } = useBackendPaginationFetcher({
		url: '/api/officer/all',
		key: 'content',
		constantSize: 10,
		mapper: (item) => ({
			...item
		})
	});

	const changeStatusTooltip = (data) => (data.active ? 'Deactivate' : 'Activate');
	const customRemoveConfirmationDialogTitle = (data) =>
		`Warning: Officer will be ${data.active ? 'Deactivated' : 'Activated'}`;
	const customeDelMessage = (data) => {
		return `Are you sure you want to ${data.active ? 'Deactivate' : 'Activate'} officer ?`;
	};
	const handleActivateAndDeactivate = async (data) => {
		try {
			const requestBody = {
				badgeNo: data.badgeNo,
				active: !data.active,
				arrestingAgencyId: data.arrestingAgencyOriDTO?.arrestingAgencyOriId,
				newPersonDTO: {
					lastName: data?.newPersonDTO?.lastName,
					firstName: data?.newPersonDTO?.firstName,
					middleName: data?.newPersonDTO?.middleName,
					suffix: data?.newPersonDTO?.suffix,
					classification: 'Person',
					personId: data.newPersonDTO?.personId
				}
			};
			const response = await putOfficerData(data.officerId, requestBody);
			if (SUCCESSFUL_REQUEST_CODE.includes(response.status)) {
				const responseData = response.data;
				setToast({
					show: true,
					text: `${responseData?.officerName} Offcer ${
						responseData.active ? 'actived' : 'deactivated'
					} successfully.`,
					type: TOAST_TYPES.SUCCESS
				});
				refreshTable();
				setFormValues({});
			}
		} catch (error) {
			console.error();
		}
	};
	const handleRowClick = (rowData) => {
		const { active } = rowData;
		if (!active) {
			setToast({
				show: true,
				text: `Warning: ${rowData.officerName} was deactivated.`,
				type: TOAST_TYPES.WARNING
			});
		} else {
			setFormType(FormType.edit);
			setFormValues(rowData);
			setShowFormDialog(true);
		}
	};

	return (
		<>
			<LeftPanel>
				<MaintenanceLeftSideNavigation />
			</LeftPanel>
			<CenterPanel>
				<BreadcrumbNav />
				<PageHeading title={'Officer Maintenance'} subTitle={'View All'} />
				<ResponseAlert
					show={toast.show}
					text={toast.text}
					type={toast.type}
					close={() => setToast({ show: false, text: '', type: '' })}
				/>
				<TableWithIntegration
					tableId="officer-maintenance-table"
					data={data}
					columns={coulmns}
					showActions={true}
					exportCSV={true}
					exportPDF={true}
					customOrder={true}
					limitRows={true}
					showSearch={true}
					enableDelete={permissions.update}
					deleteRequest={(rowData) => {
						handleActivateAndDeactivate(rowData);
					}}
					paginationItems={paginationItems}
					enableRowFunction={permissions.update}
					clickedRowFunction={handleRowClick}
					isLoading={isLoading}
					entity={'officer'}
					activateOrDeactivateLabel
					customRemoveConfirmationDialogTitle={customRemoveConfirmationDialogTitle}
					customDelMessage={customeDelMessage}
					deleteRowTooltipLabel={changeStatusTooltip}
				/>
				{showFormDialog && (
					<OfficerForm
						formData={formValues}
						showModal={showFormDialog}
						setShowModal={setShowFormDialog}
						setToast={setToast}
						type={formType}
						onSuccessCallBack={() => {
							refreshTable();
						}}
					/>
				)}
			</CenterPanel>
			<RightPanel>
				<h3>Actions</h3>
				<Button
					varient="primary"
					onClick={() => {
						setShowFormDialog(true);
						setFormType(FormType.add);
					}}
					disabled={!permissions.create}
				>
					New officer
				</Button>
			</RightPanel>
		</>
	);
};

export default OfficerMaintenance;
